import * as React from 'react';
import { ChevronLeftIcon } from 'lucide-react';

import { PaginationLink } from './pagination-link';

export function PaginationPrevious(
    props: React.ComponentProps<typeof PaginationLink>
) {
    return (
        <PaginationLink aria-label="Go to previous page" {...props}>
            <ChevronLeftIcon className="size-6" />
        </PaginationLink>
    );
}
